import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { SUPPORTED_CURRENCIES } from '../utils/currency';
import './CurrencySelector.css';

const CurrencySelector: React.FC = () => {
  const { currency, setCurrency, isLoading } = useCurrency();

  if (isLoading) {
    return null;
  }

  return (
    <div className="currency-selector">
      <label htmlFor="currency-select" className="currency-label">
        Currency:
      </label>
      <select
        id="currency-select"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="currency-select"
      >
        {SUPPORTED_CURRENCIES.map((curr) => (
          <option key={curr.code} value={curr.code}>
            {curr.code} - {curr.name} ({curr.symbol})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelector;

